export default {
  theme: {
    blue: 'Blue',
    teal: 'Teal',
    rose: 'Rose',
    violet: 'Violet',
    orange: 'Orange',
  },
  home: {
    started: "Get Started",
    components: "Components",
    tableOfContent: "Table Of Content",
    version: "version",
    changelog: "changelog",
    download: "download",
  },
  toolbar: {
    plus: 'Plus',
    account: 'Account',
    logout: 'Logout',
    setting: 'Setting',
    theme: 'Theme',
    language: 'Language',
    date: 'Select Date',
    create: 'Create',
  },
  task: {
    task: 'Task',
    name: 'Task Name',
    addTask: 'Add Task',
    editTask: 'Edit Task',
    taskTitle: 'Task Title',
    project: 'Project',
    projectId: 'Project ID',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectStartDate: 'Select Start Date',
    selectEndDate: 'Select End Date',
    executor: 'Executor',
    selectExecutor: 'Select Executor',
    selectProject: 'Select Project',
    sponsor: 'Sponsor',
    save: 'Save',
    cancel: 'Cancel',
    start: 'Start',
    end: 'End',
    pleaseEnterTaskTitle: 'Please enter task title',
    listView: 'List View',
    cardView: 'Card View',
  },
  project: {
    project: 'Project',
    projectList: 'Project List',
    projectDetail: 'Project Detail',
    projectInfo: 'Project Information',
    createProject: 'Create Project',
    createFirstProject: 'Create First Project',
    noProjects: 'No Projects',
    selectProject: 'Select Project',
    name: 'Project Name',
    nameRequired: 'Please enter project name',
    code: 'Project Code',
    version: 'Version',
    purpose: 'Purpose',
    target: 'Target',
    remark: 'Remark',
    createAt: 'Created At',
    taskList: 'Task List',
    projectNotFound: 'Project Not Found',
    createSuccess: 'Project created successfully',
    createFailed: 'Failed to create project',
    updateSuccess: 'Project updated successfully',
    updateFailed: 'Failed to update project',
    deleteSuccess: 'Project deleted successfully',
    deleteFailed: 'Failed to delete project',
    confirmDelete: 'Are you sure you want to delete this project?',
    type: 'Project Type',
    abbr: 'Abbreviation',
    profile: 'Profile',
    order: 'Order',
    train: 'Train',
    sectum: 'Sectum',
    section: 'Section',
    assembly: 'Assembly',
    source: 'Source',
    machine: 'Machine',
    system: 'System',
    standard: 'Standard',
    industry: 'Industry',
    technology: 'Technology',
    total: 'Total',
    involved: 'Involved',
    created: 'Created',
    quantity: 'Quantity',
    create: 'Create',
    dashboard: 'Dashboard',
    task: 'Task',
    file: 'File',
    product: 'Product',
    member: 'Member',
    fileList: 'File List',
    productList: 'Product List',
    memberList: 'Member List',
    listView: 'List View',
    cardView: 'Card View',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    more: 'More',
    message: 'Message',
    notice: 'Notice',
    contact: 'Contact',
    userLogin: 'User Login',
    userLogout: 'User Logout',
    previous: 'Previous',
    next: 'Next',
    goToSlide: 'Go to slide {index}',
    confirmDelete: 'Are you sure you want to delete this task?',
    carouselImage: 'Carousel image {index}',
    collapseCode: 'Collapse Code',
    expandCode: 'Expand Code',
    copyCode: 'Copy Code',
    totalTasks: 'Total Tasks',
    hide: 'Hide',
    show: 'Show',
    completed: 'Completed',
    total: 'Total',
    quantity: 'Quantity',
    pleaseSelect: 'Please Select',
    pleaseInput: 'Please Input',
    selectUser: 'Select User',
    back: 'Back',
  },
  date: {
    previousYear: 'Previous Year',
    nextYear: 'Next Year',
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    today: 'Today',
    clear: 'Clear',
    now: 'Now',
  },
  document: {
    document: 'Document',
    title: 'Document Title',
    content: 'Document Content',
    author: 'Author',
    category: 'Category',
    tags: 'Tags',
    status: 'Status',
    published: 'Published',
    draft: 'Draft',
    archived: 'Archived',
    views: 'Views',
    likes: 'Likes',
    comments: 'Comments',
    create: 'Write Document',
    edit: 'Edit Document',
    delete: 'Delete Document',
    publish: 'Publish',
    unpublish: 'Unpublish',
    listView: 'List View',
    cardView: 'Card View',
  },
};
